<template>
  <div class='project-container'>
    <div class="banner">
      <img
        class="bg"
        src="../../../assets/joinus/project/kv.png"
        alt=""
        srcset=""
      />

      <div class="box">
        <div class="tit-text">项目合作</div>

        <div class="inp1">
          <el-input v-model="form.name" placeholder="姓名"></el-input>
          <el-input v-model="form.phone" maxlength="11" placeholder="手机号码"></el-input>
        </div>

        <div class="inp2">
          <el-cascader
            v-model="form.value"
            :options="cityList"
            popper-class="popperinp2"
            placeholder="地址信息"></el-cascader>

        </div>

        <div class="content">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="项目概况.."
            v-model="form.textarea">
          </el-input>
        </div>

        <div class="btn">
          <el-button @click="toCooperate" type="primary">投资合作</el-button>
        </div>

      </div>
    </div>

    <div class="advBox" v-for="(item, index) in list" :key="index">
      <div class="left">
        <div class="adv-tit">{{ item.adv_title }}</div>
        <div class="desc">项目简介</div>

        <div class="content">
          {{ item.adv_desc }}
        </div>
      </div>
      <img class="right" :src="JSON.parse(item.adv_pic)[0].url" alt="">
    </div>

    <img v-if="isMore" @click="showMore" class="more" src="../../../assets/joinus/project/showMore.png" alt="">
  </div>
</template>

<script>
import '@/util/area'
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
import Des from '@/util/des.js'
import { doAdvertiseGeneralList } from "@/api/case.js";
import { collectInfo } from "@/api/collectInfo.js";
import { isPhone } from '@/util/utils.js'
export default {
  name: 'Project',
  components:{ 
    
  },
  props: {
    userInfo: {}
  },
  data() {
    return {
      isMore: true,
			form: {
				name: '',
				phone: '',
        value: [],
        textarea: ''
			},
      cityList: [],
      list: [],
      caseList: []
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.getCity()
    this.getList(1, 100)
  },
  mounted() {
      
  },
  methods: {
    // 合作
    toCooperate() {
      if (!('id' in this.userInfo)) {
        this.$emit('needLogin', true)
        return
      }
      if (!isPhone(this.form.phone)) {
        this.$message('手机号码格式错误')
        return false
      }
      const obj = this.cityList.filter(item => item.value === this.form.value[0])[0]
      const province = obj.label
      const obj1 = obj.children.filter(item => item.value === this.form.value[1])[0]
      let city = obj1.label
      const district = obj1.children.filter(item => item.value === this.form.value[2])[0].label
      const user_id = JSON.parse(localStorage.getItem('giftsUser')).id
      const data = {
        info_type: 3,
        name: this.form.name,
        mobile: this.form.phone,
        province,
        city,
        district,
        address: '',
        requirement: '',
        descr: this.form.textarea,
        user_id
      }
      collectInfo(data).then(res => {
        console.log(res)
        if (res.result == 1) {
          this.form = {
            name: '',
            phone: '',
            value: [],
            textarea: ''
          }
          this.$message({message: res.msg, type: 'success'})
        } else {
          this.$message(res.msg)
        }
      })
    },
    // 获取项目合作列表
    getList(pageNum, pageSize) {
      doAdvertiseGeneralList({
        adv_sign: 0,
        adv_type: '202',
        adv_state: '-1',
        keyword: '',
        pageNum,
        pageSize
      }).then((res) => {
        if (res.result == 1) {
          if (res.dataList.length > 2) {
            this.list = res.dataList.filter((item, index) => index < 2)
          } else {
            this.isMore = false
          }
          this.caseList = res.dataList
        } else {
          this.$message(res.msg)
        }
      });
    },
    showMore() {
      this.list = this.caseList
      this.isMore = false
    },
    getCity() {
      const allCityInformation = city()
      this.cityList = this.traverse(86, allCityInformation)
    },
		traverse(key, obj) {
      const objes = obj[key]
      const arr = []
      for (const i in objes) {
        arr.push({
          label: objes[i],
          value: i,
          children: obj[i] && this.traverse(i, obj)
        })
      }
      return arr
    }
  }
}
</script>
<style lang='less' scoped>
.project-container {
  .banner {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    margin-bottom: 56px;
    .bg{
      width: 100%;
      vertical-align: top;
    }
    .title{
      position: absolute;
      width: 501px;
      height: 323.5px;
      top: 269.5px;
      left: 235.5px;
    }

    .box{
      position: absolute;
      top: 143px;
      right: 362px;
      z-index: 4;
      width: 720px;
      height: 580px;
      background: #FFFFFF;
      border-radius: 25px;
      .tit-text{
        margin-top: 60px;
        font-size: 48px;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #4E8B46;
      }
      .inp1{
        display: flex;
        justify-content: space-between;
        margin-top: 32px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 50px;
        height: 50px;
        /deep/.el-input{
          width: 295px;
          height: 100%;
          .el-input__inner{
            width: 100%;
            height: 100%;
            border-radius: 25px;
            border: 1px solid #B8D4B4;
            background: #F5F8F4;
            font-size: 24px;
            &::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
          }
        }
      }

      .inp2{
        display: flex;
        justify-content: space-between;
        margin-top: 32px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 50px;
        height: 50px;
        /deep/.el-cascader{
          width: 100%;
          height: 100%;
          .el-input{
            width: 100%;
            height: 100%;
            .el-input__inner{
              width: 100%;
              height: 100%;
              border-radius: 25px;
              border: 1px solid #B8D4B4;
              background: #F5F8F4;
              font-size: 24px;
              &::placeholder {
                font-size: 24px;
                font-family: FZLanTingHeiS-R-GB;
                font-weight: 400;
                color: #ccc;
              }
            }
            .el-input__suffix{
              right: 16px;
            }
            .el-icon-arrow-down {
              position: relative;
              &:before {
                content: '';
                border-top:14px solid #B8D4B4;
                border-left:7px solid transparent;
                border-right:7px solid transparent;
                border-bottom:14px solid transparent;
                position: absolute;
                top: 17.5px;
                left: 25%;
              }
              &.is-reverse {
                transform: rotateZ(-180deg)
              }
            }
          }
        }
        /deep/.el-select{
          width: 295px;
          height: 100%;
          .el-input{
            width: 100%;
            height: 100%;
            .el-input__inner{
              width: 100%;
              height: 100%;
              border-radius: 25px;
              border: 1px solid #B8D4B4;
              background: #F5F8F4;
              &::placeholder {
                font-size: 24px;
                font-family: FZLanTingHeiS-R-GB;
                font-weight: 400;
                color: #ccc;
              }
            }
            .el-input__suffix{
              right: 16px;
            }
            .el-icon-arrow-up {
              position: relative;
              &:before {
                content: '';
                border-top:14px solid transparent;
                border-left:7px solid transparent;
                border-right:7px solid transparent;
                border-bottom:14px solid #B8D4B4;
                position: absolute;
                top: 3.5px;
                left: 25%;
              }
            }
          }
        }
      }

      .content{
        position: relative;
        margin: 0 auto;
        margin-top: 32px;
        width: 620px;
        height: 120px;
        /deep/.el-textarea{
          position: absolute;
          top: 0;
          left: 0;
          width: 620px;
          height: 120px;
          .el-textarea__inner{
            font-size: 24px;
            height: 100% !important;
            background: #F5F8F4;
            border: 1px solid #B8D4B4;
            border-radius: 25px 25px 25px 25px;
            outline: none;
            resize: none;
            &::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
          }
        }
      }

      .btn{
        position: relative;
        height: 60px;
        margin-top: 32px;
        button{
          position: absolute;
          width: 620px;
          height: 100%;
          top: 0;
          left: 50px;
        }
        /deep/.el-button--primary{
          background: #4E8B46;
          border-color: #4E8B46;
          border-radius: 25px 25px 25px 25px;
        }
        /deep/.el-button{
          font-size: 32px;
        }
      }
      
    }
  }

  .advBox{
    display: flex;
    justify-content: space-between;
    width: 1440px;
    margin: 0 auto;
    height: 500.5px;
    margin-bottom: 80px;
    .left{
      .adv-tit{
        text-align: left;
        font-size: 48px;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #009538;
      }
      .desc{
        width: 160px;
        height: 60px;
        line-height: 60px;
        background: #009538;
        border-radius: 30px 0 30px 0;
        font-size: 24px;
        color: #fff;
        margin-top: 62px;
      }
      .content{
        margin-top: 30px;
        height: 300px;
        width: 540px;
        border-top: 1px dashed #B8D4B4;
        padding: 29px 0 20px;
        font-size: 24px;
        color: #595858;
        line-height: 45px; 
        text-align: left;
      }
    }
    .right{
      width: 840.5px;
      height: 500.5px;
      border-radius: 10px;
      object-fit: cover;
    }
  }
  .more{
    width: 320px;
    vertical-align: top;
  }
}
</style>

<style lang="less">
.popperinp2 {
	margin-top: 5px!important;
	background: #F5F8F4;
	border: 1px solid #B8D4B4;
	border-radius: 25px;
	.el-select-dropdown__item{
    color: #999999;
		font-weight: normal;
		text-align: center;
		height: 47px;
		line-height: 47px;
	}
	.selected{
		color: #999999;
		font-weight: normal;
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    font-size: 24px;
		color: #4E8B46;
		font-weight: 400;
		background: none;
	}
	.el-cascader-node:not(.is-disabled){
		height: 47px;
		line-height: 47px;
	}
	.el-cascader-menu{
		font-size: 24px;
		color: #999;
	}
	.el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover{
		background: none;
	}
	.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
		color: #4E8B46;
		font-weight: 400;
		background: none;
	}
	.popper__arrow {
		display: none;
	}
}
</style>